import React, { FC } from 'react';

const cobrowseInputStyle = {
  border: 'rgb(204, 204, 204) 1px solid',
  borderRadius: '16px',
  width: '50px',
  fontSize: '14px',
  color: 'black',
  margin: '5px 5px',
  'box-sizing': 'content-box',
  '-moz-box-sizing': 'content-box',
  padding: '0 24px',
  height: '32px',
  fontWeight: 'bold'
};

interface JoinButtonProps {
  cobrowseKey: string;
  updateKey: (val: string) => void;
  display: boolean;
}

const CobrowseInput: FC<JoinButtonProps> = (
  joinButtonProps: JoinButtonProps
) => {
  const { cobrowseKey, updateKey, display } = joinButtonProps;

  return display ? (
    <input
      style={cobrowseInputStyle}
      type="text"
      autoFocus
      value={cobrowseKey}
      placeholder={'1234'}
      onChange={(e) => updateKey(e.target.value)}
    />
  ) : null;
};

export default CobrowseInput;
